import React from 'react';
import ReactDOM from 'react-dom';
import { createMemoryHistory } from 'history';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
// import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';

const history = createMemoryHistory();

ReactDOM.render(
  <React.StrictMode>
    <Router history={history}>
        <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// serviceWorker.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

